import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { selectGroupLabelStyles } from './Label.styles.css';

type LabelProps = {
    htmlFor?: string;
    onClick?: () => void;
    children: React.ReactNode;
};

export const Label: React.FC<LabelProps> = ({ htmlFor, onClick, children }) => (
    <label
        htmlFor={htmlFor}
        onClick={onClick}
        className={`${selectGroupLabelStyles()} ${fontGroups.ladle}`}
    >
        {children}
    </label>
);
